// extracted by mini-css-extract-plugin
export var page = "style-module--page--a4f30";